module.exports = __webpack_public_path__ + "static/media/reports.2d49d20f.svg";